import React from "react";
import { useSearchParams } from "react-router-dom";
import { getFuelFromParams } from "../../../utils/routeUtils";
import { RemoveSupplyPublicFormGas } from "./RemoveSupplyPublicFormGas";
import { RemoveSupplyPublicFormElectricity } from "./RemoveSupplyPublicFormElectricity";

const RemoveSupplyPublicFormWrapper: React.FC = () => {
  const [searchParams] = useSearchParams();
  const fuel = getFuelFromParams(searchParams);

  // If fuel=gas, render the gas form, otherwise render the electric form
  if (fuel === "gas") {
    return <RemoveSupplyPublicFormGas />;
  }

  // Default to electric form (fuel === 'elec' or no parameter)
  return <RemoveSupplyPublicFormElectricity />;
};

export default RemoveSupplyPublicFormWrapper;
